import { render } from "./portal-user-list.vue?vue&type=template&id=098deb8a"
import script from "./portal-user-list.vue?vue&type=script&lang=js"
export * from "./portal-user-list.vue?vue&type=script&lang=js"
script.render = render

export default script